<script>
export default {
  name: "Maintenance"
}
</script>

<template>
  <div class="maintenance">
    <div class="content">
      <h1>Regresaremos pronto!</h1>
      <p>La aplicación se encuentra en mantenimiento programado. Por favor regresa más tarde.</p>
      <p>Horario de mantenimiento: Lunes 18 de noviembre a las 18:00 a Martes 19 de noviembre a las 02:00.</p>
    </div>
  </div>
</template>

<style scoped lang="scss">
.maintenance {
  text-align: center;
  display: block;
  height: 100vh;
  position: relative;
}
.content {
  display: block;
  position: absolute;
  top: 45%;
  width: 100%;
}
</style>
